import styled, { keyframes } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const slideDown = keyframes`
from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }`;

export const Wrapper = styled.div`
    background: #3b1f62;
    width: 100%;
    animation: ${slideDown} 0.35s ease-out forwards;

    @supports (padding-top: var(--sat)) {
        padding-top: var(--sat, 0px);
    }
`;

export const ScrollContainer = styled.div(({ theme }) => ({
    overflow: "hidden",
    height: theme.spacing.xLarge,
}));

export const ScrollTextItem = styled.div<{ yPosition?: number }>(({ theme, yPosition }) => ({
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: `translateY(-${yPosition}%)`,
    transition: "transform 0.2s ease-in-out",
    color: theme.colors[theme.colorMode].background_Primary,
    willChange: "transform",
}));

export const ScrollText = styled(Text)({
    textTransform: "uppercase",
});
